import { readItem } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import type { Promoter } from '../../../../types/DirectusSchema';
import { directusClient } from '../../services/directusClient/directusClient.ts';
import { getPromoterId } from '../user/getPromoterId.ts';
import { useUserQuery } from '../user/useUserQuery.ts';

const parsePromoter = (promoter: Promoter) => {
  // Typed as string, but the API returns the integer id of the incomplete event.
  const onboardingEvent: unknown = promoter.onboarding_event;

  return {
    ...promoter,
    onboarding_event:
      typeof onboardingEvent === 'number' || typeof onboardingEvent === 'string' ? String(onboardingEvent) : null,
  };
};

export const usePromoterItemQuery = () => {
  const { data } = useUserQuery();
  const promoterId = getPromoterId(data);

  return useQuery({
    queryKey: ['promoter', promoterId],

    queryFn: async () => {
      if (!promoterId) throw new Error('No promoter linked to this user');

      const result = await directusClient.request(readItem('promoters', promoterId));

      return parsePromoter(result as unknown as Promoter);
    },
    enabled: !!promoterId,
  });
};
